import React, { useEffect, useState } from "react";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import GoalButton from "layouts/goals/components/GoalButton";
import FieldLabel from "./FieldLabel";
import { ASSETS_MESSAGES, personName } from "../assets.constants";

const todayStr = () => moment().format("YYYY-MM-DD");

function ReturnAssetModal({ open, onClose, onReturn, isSubmitting, asset }) {
  const assignment = asset?.current_assignment;
  const [date, setDate] = useState(todayStr());
  const [notes, setNotes] = useState("");
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    setDate(todayStr());
    setNotes("");
    setLocalError(null);
  }, [open, asset]);

  const handleReturn = async () => {
    if (assignment && date < assignment.assigned_at) {
      return setLocalError(ASSETS_MESSAGES.returnBeforeAssigned);
    }
    setLocalError(null);
    await onReturn(asset.id, { date: date || todayStr(), notes });
  };

  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>Return asset</DialogTitle>
      <DialogContent>
        <SuiTypography variant="button" color="text" display="block" mb={2}>
          {asset?.name} comes back from {personName(assignment?.user)} and goes back into stock.
        </SuiTypography>
        {localError && (
          <SuiTypography variant="caption" color="error" display="block" mb={1}>
            {localError}
          </SuiTypography>
        )}
        <SuiBox mb={2}>
          <FieldLabel>Returned on</FieldLabel>
          <SuiInput type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </SuiBox>
        <FieldLabel>Notes</FieldLabel>
        <SuiInput
          multiline
          rows={2}
          placeholder="Optional, e.g. condition or missing accessories"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton
          variant="primary"
          icon="assignment_return"
          loading={isSubmitting}
          onClick={handleReturn}
        >
          Return
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default ReturnAssetModal;
